const UTM_STORAGE_KEY = 'novelday:utm-params';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

const isAvailable = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.sessionStorage != null;
  } catch (_error) {
    return false;
  }
};

export const captureUtmParamsFromSearch = (search) => {
  if (!isAvailable() || !search) {
    return;
  }
  try {
    const params = new URLSearchParams(search);
    const found = {};
    let hasAny = false;
    for (const key of UTM_KEYS) {
      const value = params.get(key);
      if (value) {
        found[key] = value;
        hasAny = true;
      }
    }
    if (hasAny) {
      window.sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(found));
    }
  } catch (_error) {
  }
};

export const getStoredUtmParams = () => {
  if (!isAvailable()) {
    return {};
  }
  try {
    const raw = window.sessionStorage.getItem(UTM_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (_error) {
    return {};
  }
};
